import * as z from "zod/v4";
import { calendarEntry, marketingCalendarEntryInput } from "./calendar-entry";

export const updateCalendarEntry = {
  name: "updateCalendarEntry" as const,
  input: marketingCalendarEntryInput.extend({ id: z.string() }),
  output: calendarEntry,
};
